module.exports = __webpack_public_path__ + "img/jyl_banner_phone.5bd60089.png";